import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Section from './section';
import Container from './container';
import Column from './column';

export default ({ bricks }) => {
  const query = useStaticQuery(graphql`query SectionQuery {
  allEckPageBodySection {
    edges {
      node {
        drupal_id
        field_background_color {
          color
          opacity
        }
        relationships {
          field_background_image {
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  allEckPageBodyContainer {
    edges {
      node {
        id
        drupal_id
        field_row_justification
        field_fluid
        field_classes
      }
    }
  }
  allEckPageBodyColumn {
    edges {
      node {
        drupal_id
        field_classes
        relationships {
          field_column_spans {
            field_span_md
            field_span_xl
            field_span_xs
          }
          field_components {
            ... on paragraph__component_button_s {
              internal {
                type
              }
              relationships {
                field_button_s {
                  field_link {
                    title
                    uri
                  }
                }
              }
            }
            ... on paragraph__component_form {
              internal {
                type
              }
              field_form_id
              field_form_id_2
            }
            ... on paragraph__component_heading {
              internal {
                type
              }
              field_heading
              field_heading_type
            }
            ... on paragraph__component_html {
              internal {
                type
              }
              field_html {
                processed
                value
              }
            }
            ... on paragraph__component_list {
              internal {
                type
              }
              field_number_of_columns
              field_text_plain_long_repeater
            }
            ... on paragraph__component_paragraph_s {
              internal {
                type
              }
              relationships {
                field_paragraph_s {
                  field_paragraph
                }
              }
            }
            ... on paragraph__component_video {
              internal {
                type
              }
              field_youtube
              relationships {
                field_poster {
                  field_media_image {
                    alt
                  }
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          gatsbyImageData(width: 800, layout: CONSTRAINED)
                        }
                        publicURL
                      }
                    }
                  }
                }
              }
            }
            ... on paragraph__component_image {
              internal {
                type
              }
              field_fluid
              relationships {
                field_image {
                  field_media_image {
                    alt
                  }
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          gatsbyImageData(layout: FULL_WIDTH)
                        }
                        publicURL
                      }
                    }
                  }
                }
              }
            }
            ... on paragraph__component_showcase_cards {
              internal {
                type
              }
              id
              relationships {
                field_content_type {
                  info
                  relationships {
                    paragraph__component_showcase_cards {
                      id
                    }
                  }
                }
              }
            }
            ... on paragraph__component_showcase_feed {
              internal {
                type
              }
              id
              relationships {
                field_content_type {
                  info
                  relationships {
                    paragraph__component_showcase_feed {
                      id
                    }
                  }
                }
              }
            }
            ... on paragraph__component_showcase_grid {
              internal {
                type
              }
              id
              relationships {
                field_content_type {
                  info
                  relationships {
                    paragraph__component_showcase_grid {
                      id
                    }
                  }
                }
              }
            }
            ... on paragraph__component_carousel_ribbon {
              id
              internal {
                type
              }
              relationships {
                field_content_type {
                  info
                  relationships {
                    paragraph__component_carousel_ribbon {
                      id
                    }
                  }
                }
              }
            }
            ... on paragraph__component_carousel_default {
              id
              internal {
                type
              }
              relationships {
                field_content_type {
                  info
                  relationships {
                    paragraph__component_carousel_default {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`);
  //   ... on paragraph__component_image_ticker {
  //                 id
  //                 internal {
  //                   type
  //                 }
  //                 relationships {
  //                   field_content_type {
  //                     info
  //                     relationships {
  //                       paragraph__component_image_ticker {
  //                         id
  //                       }
  //                     }
  //                   }
  //                 }
  //               }
  // console.log(query)

  if (bricks.length === 0) return null;

  return bricks.map((brick, index) => {
    //////////////////////////////////////////////////
    // TYPE: Section
    if (brick.type === 'eck_page_body__section') {
      let section = query.allEckPageBodySection.edges.find((edge) => {
        return edge.node.drupal_id === brick.id ? true : false;
      }).node;
      return (
        <Section
          id={`ID_${brick.id}`}
          background_color={section.field_background_color}
          background_image={
            section.relationships.field_background_image
              ? {
                  src:
                    section.relationships.field_background_image !==
                    null
                      ? section.relationships.field_background_image
                          .relationships.field_media_image.localFile
                      : null,
                  alt: section.relationships.field_background_image
                    .field_media_image
                    ? section.relationships.field_background_image
                        .field_media_image.alt
                    : null,
                }
              : null
          }
          children={brick.children}
          key={index}
        />
      );
    }
    //////////////////////////////////////////////////
    // TYPE: Container
    else if (brick.type === 'eck_page_body__container') {
      let container = query.allEckPageBodyContainer.edges.find(
        (edge) => {
          return edge.node.drupal_id === brick.id ? true : false;
        }
      ).node;
      return (
        <Container
          id={`ID_${brick.id}`}
          className={container.field_classes}
          fluid={container.field_fluid}
          row_justification={container.field_row_justification}
          children={brick.children}
          key={index}
        />
      );
    }
    //////////////////////////////////////////////////
    // TYPE: Column
    else if (brick.type === 'eck_page_body__column') {
      let column = query.allEckPageBodyColumn.edges.find((edge) => {
        return edge.node.drupal_id === brick.id ? true : false;
      }).node;
      return (
        <Column
          xs={
            column.relationships.field_column_spans &&
            column.relationships.field_column_spans.field_span_xs
          }
          md={
            column.relationships.field_column_spans &&
            column.relationships.field_column_spans.field_span_md
          }
          xl={
            column.relationships.field_column_spans &&
            column.relationships.field_column_spans.field_span_xl
          }
          components={column.relationships.field_components}
          children={brick.children}
          key={index}
        />
      );
    } else
      return (
        <p key={index}>
          Requested content is not known (from Bricks.js)
        </p>
      );
  });
};
